'use client';
// Pro "אודות" card (21/10/26, compact): ONE card — title row with the "active since" chip opposite, lead text with an inline
// "קרא עוד", services as one scrolling chip row (children), key points behind the toggle. Full text stays in the DOM.
import { useId, useState } from 'react';

export default function ProAboutText({ lead, facts, points, children }: { lead: string; facts: string[]; points: string[]; children?: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = `pro-about-points-${useId()}`;
  return (
    <div className="rounded-2xl" style={{ background: '#fff', border: '1px solid #e2e8f0', padding: '10px 12px' }}>
      <div className="flex items-center justify-between gap-2" style={{ marginBottom: 4 }}>
        <h3 className="text-sm font-bold flex items-center gap-1.5" style={{ color: '#111', margin: 0 }}>👤 אודות</h3>
        {facts.map((f) => (
          <span key={f} className="text-xs font-medium rounded-full" style={{ background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0', padding: '2px 9px', whiteSpace: 'nowrap' }}>{f}</span>
        ))}
      </div>
      <p className="text-sm" style={{ color: '#374151', margin: 0, lineHeight: 1.5 }}>
        {lead}
        {points.length > 0 && (
          <>{' '}<button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls={id}
            className="text-xs font-semibold" style={{ background: 'none', border: 'none', color: '#1d4ed8', cursor: 'pointer', padding: '14px 8px', margin: '-14px -4px', minHeight: 44, minWidth: 44, whiteSpace: 'nowrap' }}>
            {open ? 'הצג פחות ▴' : 'קרא עוד ▾'}
          </button></>
        )}
      </p>
      {points.length > 0 && (
        <ul id={id} hidden={!open} style={{ listStyle: 'none', padding: 0, margin: '6px 0 0', display: open ? 'grid' : 'none', gap: 5 }}>
          {points.map((p, i) => (
            <li key={i} className="text-sm" style={{ color: '#374151', display: 'flex', gap: 6, alignItems: 'flex-start', lineHeight: 1.45 }}>
              <span aria-hidden="true" style={{ color: '#16a34a', fontWeight: 700 }}>✓</span><span>{p}</span>
            </li>
          ))}
        </ul>
      )}
      {children}
    </div>
  );
}
